import NPreview from "./NPreview";

export default function NewingArea() {

    return (
        <div className="newingArea row-start-3 row-end-13   col-start-1 col-end-13 w-full  py-8 px-4 2xl:px-8 ">
            <NPreview />
        </div>
    );
}